<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aWnLuy/tc-custom/9780743213578.jpg?1730526158324" alt="This image is the cover for the book Many Lives & Secret Sorrows of Josephine B."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Many Lives & Secret Sorrows of Josephine B.
      </h1>
      <p class="bookDescription body article font2">
        <b>Passion intertwines with fate in this riveting and historically rich novel about the journey of a woman from poverty to ultimate power in Revolution-era France. </b><br/><br/>In this first of three books inspired by the life of Josephine Bonaparte, Sandra Gulland has created a novel of immense and magical proportions. We meet Josephine in the exotic and lush Martinico, where an old island woman predicts that one day she will be queen. The journey from the remote village of her birth to the height of European elegance is long, but Josephine's fortune proves to be true. By way of fictionalized diary entries, we traverse her early years as she marries her one true love, bears his children, and is left betrayed, widowed, and penniless. It is Josephine's extraordinary charm, cunning, and will to survive that catapults her to the heart of society, where she meets Napoleon, whose destiny will prove to be irrevocably intertwined with hers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Gulland
      </h2>
      
      <p class="authorDescription body article"><I>Sandra Gulland</I> is the author of&#160; <I>Mistress of the Sun; The Many Lives &amp; Secret Sorrows of Josephine B.; Tales of Passion, Tales of Woe</I>; and <I>The Last Great Dance on Earth</I>. She lives in Killaloe, Ontario, and San Miguel de Allende, Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?398d4033